import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gs-icon-sprites',
  templateUrl: './gs-icon-sprites.component.html',
  styleUrls: ['./gs-icon-sprites.component.scss'],
})
export class GsIconSpritesComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
